import { type ICategory } from '@mahawi/eshop-common/dist/src/types';

export const getCategoryUrl = (
  category: Pick<ICategory, 'uuid' | 'slugs'>,
  languageCode: string,
): string => {
  const lngCode = languageCode.toLowerCase();
  const slug = category.slugs?.find((s) => s.code === languageCode)?.value;
  return slug
    ? `/${lngCode}/c/${slug}`
    : `/${lngCode}/category/${category.uuid}`;
};
